import DuInput from './components/wrap'

export default DuInput
